import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
const offerings = [{
  id: 'eat',
  title: 'Culinary Excellence',
  subtitle: 'EAT',
  desc: 'A boutique collection of Ethiopian-inspired flavors and contemporary bar bites.',
  image: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?auto=format&fit=crop&q=80&w=800',
  link: '/eat',
  color: 'hover:border-champagne hover:shadow-[0_0_30px_rgba(197,160,89,0.2)]'
}, {
  id: 'drink',
  title: 'Signature Spirits',
  subtitle: 'DRINK',
  desc: 'Sophisticated spirits and masterfully crafted cocktails for the discerning palate.',
  image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&q=80&w=800',
  link: '/drink',
  color: 'hover:border-champagne hover:shadow-[0_0_30px_rgba(197,160,89,0.2)]'
}, {
  id: 'nightlife',
  title: 'Legendary Events',
  subtitle: 'NIGHTLIFE',
  desc: 'The pulse of DC. From high-energy sports to exclusive late-night vibes.',
  image: 'https://images.unsplash.com/photo-1566737236500-c8ac43014a67?auto=format&fit=crop&q=80&w=800',
  link: '/nightlife',
  color: 'hover:border-crimson hover:shadow-[0_0_30px_rgba(219,32,39,0.3)]'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: 'easeOut'
    }
  }
};
export function Experience() {
  return <section className="py-16 md:py-24 bg-obsidian overflow-hidden relative" data-id="element-14">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3/4 h-3/4 bg-crimson/5 blur-[120px] pointer-events-none" data-id="element-15" />

      <div className="max-w-7xl mx-auto px-6 md:px-8 relative z-10" data-id="element-16">
        <div className="text-center mb-16 md:mb-20" data-id="element-17">
          <motion.span initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-xs md:text-sm tracking-[0.4em] text-crimson uppercase font-sans mb-4 block" data-id="element-18">
            The Red Lounge Experience
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-4xl md:text-6xl font-serif text-white" data-id="element-19">
            Choose Your Vibe
          </motion.h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-20">
          {offerings.map(item => <motion.div key={item.id} variants={itemVariants} className="h-full" data-id="element-21">
              <Link to={item.link} className="block h-full group" data-id="element-22">
                <div className={`relative h-[500px] md:h-[600px] w-full overflow-hidden border border-white/10 bg-obsidian transition-all duration-500 ${item.color}`} data-id="element-23">
                  {/* Image */}
                  <img src={item.image} alt={item.title} className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-40 group-hover:scale-110 transition-all duration-700 ease-out" data-id="element-24" />

                  {/* Gradient Overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/50 to-transparent opacity-90 group-hover:opacity-100 transition-opacity duration-500" data-id="element-25" />

                  {/* Content */}
                  <div className="absolute inset-0 p-8 flex flex-col justify-end" data-id="element-26">
                    <motion.div className="transform transition-transform duration-500 group-hover:-translate-y-4" data-id="element-27">
                      <span className="text-[10px] tracking-[0.4em] text-champagne uppercase font-sans mb-3 block" data-id="element-28">
                        {item.subtitle}
                      </span>
                      <h3 className="text-3xl font-serif text-white mb-4 group-hover:text-champagne transition-colors duration-300" data-id="element-29">
                        {item.title}
                      </h3>
                      <p className="text-white/60 font-sans text-sm md:text-base leading-relaxed mb-6 opacity-0 translate-y-4 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500 delay-100" data-id="element-30">
                        {item.desc}
                      </p>

                      <div className="flex items-center gap-4 text-xs uppercase tracking-[0.3em] font-serif text-white group-hover:text-crimson transition-colors duration-300" data-id="element-31">
                        Explore
                        <div className="w-8 h-[1px] bg-white group-hover:bg-crimson group-hover:w-16 transition-all duration-500" data-id="element-32" />
                      </div>
                    </motion.div>
                  </div>
                </div>
              </Link>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}